import { atom } from "recoil";
import { client } from "helpers/client";

interface LookUp {
  id: number;
  name: string;
  phoneCode?: string;
}

export interface ContactRequest {
  helpMessage: string;
  fullName: string;
  country: string;
  mobileNumber: string;
  fromEmail: string;
  companyName: string;
  industry: string;
  companySize: string;
  message: string;
}

interface Address {
  id: number;
  city: string;
  country: string;
  street: string;
  latitude: string;
  longitude: string;
  phone1: string;
  phone2: string;
}

export const AddressAtom = atom<Address | null>({
  default: null,
  key: "address",
});

export class ContactService {
  static getAddresses() {
    return client<Address[]>("/contactUs/DexefBranch/getAll");
  }

  static createContactRequest(data: ContactRequest) {
    return client("/contactUs/create", { data });
  }

  static getHelpOptions() {
    return client<LookUp[]>("contactUs/helpOption/getAll").then(
      (res) => res.response ?? []
    );
  }
}
